import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import {
  PATH_DASHBOARD_HEADCOUNT,
  PATH_DASHBOARD_NTS,
  PATH_DASHBOARD_NTS_BY_EMPLOYEE,
  PATH_DASHBOARD_PLACEMENT_GOAL,
  PATH_DASHBOARD_PERM_PLACEMENT_GOAL,
  PATH_DASHBOARD_LABOR_EFFICIENCY_RATIO,
  PATH_DASHBOARD_REVENUE_DATA,
  PATH_DASHBOARD_UPCOMING_INTERVIEWS,
  PATH_DASHBOARD_RECRUITERS_PERFORMANCE_DETAILS,
  PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_YEAR,
  PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_MONTH
} from '@/lib/constants/api'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'
import updateStatus from '@/store/helpers/updateStatus'

const isBusinessEntityIdValid = (businessEntityId) => {
  return businessEntityId !== null && businessEntityId !== undefined
}

const getBusinessEntityParameters = (businessEntityId) => {
  if (!isBusinessEntityIdValid(businessEntityId) || businessEntityId === ALL_BUSINESS_ENTITIES) {
    return {}
  }

  return { businessEntityId }
}

const dashboard = {
  namespaced: true,
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField
  },
  actions: {
    getHeadcount: ({ commit }, businessEntityId = null) => {
      commit('updateStatus', { status: IN_PROGRESS })
      let parameters = getBusinessEntityParameters(businessEntityId)

      return api.doGet({ path: PATH_DASHBOARD_HEADCOUNT, parameters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getNTS: ({ commit }, businessEntityId = null) => {
      commit('updateStatus', { status: IN_PROGRESS })

      let parameters = getBusinessEntityParameters(businessEntityId)
      return api.doGet({ path: PATH_DASHBOARD_NTS, parameters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getNTSByEmployee: ({ commit }, businessEntityId = null) => {
      commit('updateStatus', { status: IN_PROGRESS })

      let parameters = getBusinessEntityParameters(businessEntityId)
      return api.doGet({ path: PATH_DASHBOARD_NTS_BY_EMPLOYEE, parameters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getPlacementGoalCurrentMonth: ({ commit }, businessEntityId = null) => {
      commit('updateStatus', { status: IN_PROGRESS })

      let parameters = getBusinessEntityParameters(businessEntityId)

      return api.doGet({ path: PATH_DASHBOARD_PLACEMENT_GOAL, parameters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getDirectPlacementGoalCurrentMonth: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_PERM_PLACEMENT_GOAL })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getLaborEfficiencyRatioData: ({ commit }, businessEntityId = null) => {
      commit('updateStatus', { status: IN_PROGRESS })

      let parameters = getBusinessEntityParameters(businessEntityId)
      return api.doGet({ path: PATH_DASHBOARD_LABOR_EFFICIENCY_RATIO, parameters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getRevenueData: ({ commit }, year = new Date().getFullYear()) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_REVENUE_DATA, parameters: Object.assign({}, { year: year }) })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getUpcomingInterviews: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_UPCOMING_INTERVIEWS })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getRecruitersPerformanceDetails: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_DASHBOARD_RECRUITERS_PERFORMANCE_DETAILS, parameters: { year: parameters.year } })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    },
    getGrossProfitDetailsByYear: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      let businessEntityParameters = getBusinessEntityParameters(parameters.businessEntityId)
      return api.doGet({ path: PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_YEAR, parameters: Object.assign({}, { year: parameters.year }, businessEntityParameters) })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          throw error
        })
    },
    getGrossProfitDetailsByMonth: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      let businessEntityParameters = getBusinessEntityParameters(parameters.businessEntityId)
      return api.doGet({ path: PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_MONTH, parameters: Object.assign({}, { year: parameters.year, month: parameters.month }, businessEntityParameters) })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          throw error
        })
    }
  }
}

export default dashboard
